<template>
	<Panel :title="'Jugadores'" :icon="'users'">
		<div class="panel-block jugadores-quiniela">
			<div class="dropdown" :class="{'is-active' : jugador.active}" v-for="jugador in jugadores" :key="jugador.id">
				<div class="dropdown-trigger">
					<div class="player" @click.prevent="openMenuPlayer(jugador)">
						<figure class="image is-48x48 is-4by3" :title="jugador.name">
							<img :src="jugador.image" alt="" class="is-rounded">
							<p class="truncate has-text-centered">{{ jugador.name }}</p>
						</figure>
					</div>
				</div>
				<div class="dropdown-menu">
					<div class="dropdown-content">
						<a class="dropdown-item" @click.prevent="verQuiniela(jugador)">Ver quiniela</a>
						<router-link class="dropdown-item" :to="'/perfil/' + jugador.id">Ver perfil</router-link>
					</div>
				</div>
			</div>
		</div>
	</Panel>
</template>

<script>
	import Panel from '@/components/Panel'

	export default {
		components: { Panel },
		props: {
			jugadores: {
				type: Array,
				default: function(){
					return []
				}
			}
		},
		name: 'JugadoresQuiniela',
		data() {
			return {
				hovered: true
			};
		},
		methods: {
			verQuiniela(jugador){
				this.closeAll()
				this.$emit('verUsuario',jugador)
			},
			openMenuPlayer(jugador){
				if (jugador.active) {
					this.$set(jugador,'active',false)
				}else{
					this.closeAll()
					this.$set(jugador,'active',true)
				}
			},
			closeAll(){
				for (var i = 0; i < this.jugadores.length; i++) {
					this.$set(this.jugadores[i],'active',false)
				}
			}
		},
		mounted(){
			this.closeAll()
		}
	};
</script>

<style lang="css" scoped>
figure{
	margin: 0 0.8em 0.5em 0;
}
figure p{
	font-size: 0.5em;
}
a{
	color: black;
}
.dropdown-menu{
	z-index: 40;
}
.player{
	cursor: pointer;
}
.jugadores-quiniela{
	flex-wrap: wrap;
}
.jugadores-quiniela .dropdown{
	margin-bottom: .75em;
}
</style>
